import { Component } from '@angular/core';
import { QuoteService } from './quote.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GenerateDocComponent } from './generate-doc/generate-doc.component';
import { HomeComponent } from './home/home.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'Toshiba Configurator';
  
  constructor( private quoteService: QuoteService,
               private activeRoute: ActivatedRoute,
               private router: Router
   ) {}
   
  ngOnInit() {
    
   this.quoteService.loadSession().subscribe();
    
    //this.router.setUpLocationChangeListener();
  }
   
  hasConfigurations(): boolean {
    return this.getConfigCount() > 0;
  }
  
  getConfigCount(): number {
    return this.quoteService.configs.length;
  }
  
  showHome(): boolean {
    
    return !this.router.isActive('', true );
  }
  
  showGenerate(): boolean {
    return !this.router.isActive('/generate', true );
  }
  
  goHome(): void {
    this.router.navigate( [ '' ] );
  }
  
  goToGenerate(): void {
    this.router.navigate( [ 'generate' ] );
  }
}
